import { FC } from 'react';
import { CalculatorCurrencyField } from '@components/common/CalculatorCurrencyField/CalculatorCurrencyField';
import { FormattedMessage, useIntl } from 'react-intl';
import { BenefitsAndCreditsQuestions } from './quesions';
import { BenefitsAndCreditsProps } from './types';

export const BenefitsAndCredits: FC<BenefitsAndCreditsProps> = ({ applicantNumber }) => {
  const intl = useIntl();
  const endAdornment = intl.formatMessage({ id: 'common.fourWeeks' });
  const { childBenefit, stateDisabilityAllowance, universalTaxCredits } = BenefitsAndCreditsQuestions;

  return (
    <div>
      <h3 className={'font-satoshi-black text-dark text-1-5xl xs:mb-5 m-0 font-black md:mb-10'}>
        <FormattedMessage id={'affordabilityCalculator.benefitsAndCredits.title'} />
      </h3>

      <CalculatorCurrencyField
        name={`applicants[${applicantNumber}].benefitsAndCredits.childBenefit`}
        titleKey={childBenefit.titleKey}
        className={'xs:mb-5 md:mb-10'}
        textFieldProps={{ InputProps: { endAdornment } }}
        isPeriod
      />
      <CalculatorCurrencyField
        name={`applicants[${applicantNumber}].benefitsAndCredits.universalTaxCredits`}
        titleKey={universalTaxCredits.titleKey}
        textFieldProps={{ InputProps: { endAdornment } }}
        className={'xs:mb-5 md:mb-10'}
        isPeriod
      />
      <CalculatorCurrencyField
        name={`applicants[${applicantNumber}].benefitsAndCredits.stateDisabilityAllowance`}
        titleKey={stateDisabilityAllowance.titleKey}
        textFieldProps={{ InputProps: { endAdornment } }}
        className={'xs:mb-6 md:mb-12'}
        isPeriod
      />
      <hr className={'border-fog xs:mb-6 border border-t-0 border-solid md:mb-12'} />
    </div>
  );
};
